import React from "react";
import { Modal, Card } from "@mui/material";
import ReactPlayer from "react-player";

const VideoPreviewModal = ({ open, onClose, url }) => {
    const isIframe = url?.includes("<iframe");

    const extractIframeHTML = (html) => {
        const start = html.indexOf("<iframe");
        const end = html.indexOf("</iframe>") + 9;
        return start !== -1 && end !== -1 ? html.substring(start, end) : "";
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
            {isIframe ? (
                <Card
                    style={{
                        width: "50%",
                        padding: "20px",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div
                        style={{ display: "flex", justifyContent: "center" }}
                        dangerouslySetInnerHTML={{ __html: extractIframeHTML(url) }}
                    />
                </Card>
            ) : (
                <div
                    className="player-wrapper"
                    style={{
                        width: "50%",
                        height: "50%",
                        padding: "20px",
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px",
                        borderRadius: "10px",
                    }}
                >
                    <ReactPlayer
                        url={url}
                        style={{
                            top: 0,
                            left: 0,
                            width: "50%",
                            padding: "5px",
                            margin: "5px",
                        }}
                        width="100%"
                        height="100%"
                        controls
                    />
                </div>
            )}
        </Modal>
    );
};

export default VideoPreviewModal;